import { useState } from 'react';
import moment from 'moment';

import { useFmrs } from 'hooks/useFmrs';
import { NsForm } from 'components/common/ns-form/NsForm';
import { NsDatepicker, DateString } from 'components/common/ns-datepicker/NsDatepicker';
import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';

import { DATE_FORMAT } from 'config/app-config';

type SupplyStartDateProps = {
  onHandleConfirm: (args: { preferredStartDate: string }) => void;
};

export const SupplyStartDate = ({ onHandleConfirm }: SupplyStartDateProps) => {
  const {
    minimumSupplyStartDate,
    maximumSupplyStartDate,
    preferredStartDate: defaultPreferredStartDate
  } = useFmrs();
  const [preferredStartDate, setPreferredStartDate] = useState(
    defaultPreferredStartDate
  );
  const value = moment(preferredStartDate, DATE_FORMAT, true).format(
    DATE_FORMAT
  );

  const handleGoNext = () => onHandleConfirm({ preferredStartDate });

  const handleChange = (event) => {
    const {
      target: { processedValue }
    } = event;
    const mProcessedValue = moment(processedValue, DATE_FORMAT, true);

    mProcessedValue.isValid() && setPreferredStartDate(processedValue);
  };

  return (
    <NsForm onSubmit={handleGoNext}>
      <NsDatepicker
        name="ssd"
        label="Pick when you'd like your supply to start"
        value={value as DateString}
        min={minimumSupplyStartDate as DateString}
        max={maximumSupplyStartDate as DateString}
        onChange={handleChange}
      />
      <NsPrimaryCta>Confirm</NsPrimaryCta>
    </NsForm>
  );
};
